//#region Imports
import React from "react";

import "../scss/Elements/_tables.scss";
import { Helmet } from "react-helmet";
import { useTranslationHook } from "../hooks/UseTranslationHook";
import { ManufacturersTable } from "../components/Tables/ManufacturersTable";
//#endregion

function InventoryManufacturers() {
  const { titleInventoryString } = useTranslationHook();

  return (
    <div className="table-module-container">
      <Helmet>
        <title>{titleInventoryString}</title>
      </Helmet>
      <div className="datatable">
      <ManufacturersTable />
      </div>
    </div>
  );
}

export default InventoryManufacturers;